import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createNit, type CreateNitRequest } from "@/api/nits";
import { TextField } from "@/components/ui/TextField";
import { showToast } from "@/components/ui/Toast";
import { FormPageShell } from "@/components/ui/FormPageShell";

export const NitNuevoPage = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const create = useMutation({
    mutationFn: (body: CreateNitRequest) => createNit(body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["nits"] });
      showToast("success", "NIT creado");
      navigate("/nits");
    },
    onError: (err: Error) =>
      showToast("error", "No se pudo crear", err.message),
  });

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    create.mutate({
      nit: String(form.get("nit") ?? "").trim(),
      razon_social: String(form.get("razon_social") ?? "").trim(),
      dv: String(form.get("dv") ?? "").trim() || undefined,
      telefono: String(form.get("telefono") ?? "").trim() || undefined,
      correo_electronico:
        String(form.get("correo_electronico") ?? "").trim() || undefined,
      direccion: String(form.get("direccion") ?? "").trim() || undefined,
      ciudad: String(form.get("ciudad") ?? "").trim() || undefined,
      pais: String(form.get("pais") ?? "").trim() || undefined,
    });
  };

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <FormPageShell
        title="Nuevo NIT"
        submitLabel="Guardar"
        onCancel={() => navigate("/nits")}
        loading={create.isPending}
      >
        <form
          onSubmit={onSubmit}
          className="space-y-3 rounded-lg bg-white p-6 shadow-card"
        >
        <div className="grid gap-3 sm:grid-cols-3">
          <TextField
            label="NIT"
            className="sm:col-span-2"
            name="nit"
            required
            placeholder="900123456"
          />
          <TextField label="DV" name="dv" maxLength={5} placeholder="1" />
        </div>
        <TextField
          label="Razón Social"
          name="razon_social"
          required
          placeholder="Empresa SAS"
        />
        <div className="grid gap-3 sm:grid-cols-2">
          <TextField
            label="Correo Electrónico"
            name="correo_electronico"
            type="email"
            placeholder="contacto@empresa.com"
          />
          <TextField
            label="Teléfono"
            name="telefono"
            placeholder="+57 300 123 4567"
          />
        </div>
        <TextField label="Dirección" name="direccion" placeholder="Calle 1 # 2-3" />
        <div className="grid gap-3 sm:grid-cols-2">
          <TextField label="Ciudad" name="ciudad" placeholder="Bogotá" />
          <TextField label="País" name="pais" placeholder="Colombia" />
        </div>
      </form>
    </FormPageShell>
    </div>
  );
};
